function toDegrees(radians: number): number {
  return (radians * 180) / Math.PI;
}

/**
 * Calculates the vertical angle from observer to feature using horizontal
 * geodesic distance and altitude difference. Positive values indicate that
 * the feature is above the observer.
 */
export function calculateElevationAngle(
  horizontalDistanceMeters: number,
  observerAltitudeMeters: number,
  featureAltitudeMeters: number,
): number {
  if (!Number.isFinite(horizontalDistanceMeters) || horizontalDistanceMeters < 0) {
    throw new RangeError("horizontalDistanceMeters must be a finite non-negative number.");
  }
  if (!Number.isFinite(observerAltitudeMeters) || !Number.isFinite(featureAltitudeMeters)) {
    throw new RangeError("altitudes must be finite numbers.");
  }

  const altitudeDifference = featureAltitudeMeters - observerAltitudeMeters;
  if (horizontalDistanceMeters === 0) {
    if (altitudeDifference === 0) {
      return 0;
    }
    return altitudeDifference > 0 ? 90 : -90;
  }

  return toDegrees(Math.atan2(altitudeDifference, horizontalDistanceMeters));
}
